import Video from '../../pages/video'

const VideoRoute = [
  {
    path: '/video',
    name: 'video',
    component: Video
  }
]

export default VideoRoute



// WEBPACK FOOTER //
// ./src/router/video/index.js